import React from "react";
import axios from "axios";
import api from "../../common/api";
import {
  TextField,
  Button,
  InputAdornment,
  Typography,
  Snackbar
} from "@material-ui/core";
import { useEffect, useState } from "react";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const SAP = ({ work_order, onUpdateWorkOrderState }) => {
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const forceOCSAP = async () => {
    setSaving(true);
    var formData = new FormData();
    var url = api.work_order().forceOCSAP();
    formData.set("work_order[id]", work_order.id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        setSaving(false);
        setSnackbar({
          open: true,
          message: "OC Creada con éxito",
          severity: "success"
        });
        onUpdateWorkOrderState();
      })
      .catch(function(error) {
        //	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
        var error_message = "Ha ocurrido un error al crear la OC SAP";
        var errors = error.response.data;

        if (errors.errors) {
          if (errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message.concat(error.message).concat(" ");
          }
        }

        if (errors.sap_response) {
          error_message = error_message
            .concat(" Respuesta SAP: ")
            .concat(errors.sap_response.body);
        }
        setSaving(false);
        setSnackbar({
          open: true,
          message: error_message,
          severity: "error"
        });
        onUpdateWorkOrderState();
      });
  };

  const forceReceptionSAP = async () => {
    setSaving(true);
    var formData = new FormData();
    var url = api.work_order().forceReceptionSAP();
    formData.set("work_order[id]", work_order.id);
    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        setSaving(false);
        setSnackbar({
          open: true,
          message: "Recepcion Creada con éxito",
          severity: "success"
        });
        onUpdateWorkOrderState();
      })
      .catch(function(error) {
        //	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
        var error_message = "Ha ocurrido un error al crear la Recepcion en SAP";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message.concat(error.message).concat(" ");
          }
        }
        if (errors.sap_response) {
          error_message = error_message
            .concat(" Respuesta SAP: ")
            .concat(errors.sap_response.body);
        }

        setSaving(false);
        setSnackbar({
          open: true,
          message: error_message,
          severity: "error"
        });
        onUpdateWorkOrderState();
      });
  };

  const deleteOCSAP = async () => {
    setSaving(true);
    var url = api.work_order().forceReceptionSAP();
    let self = this;
    const token = localStorage.getItem("userToken");
    await axios
      .delete(
        api.work_order().forceOCSAP(work_order.id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { "work_order[id]": work_order.id } }
      )
      .then(response => {
        setSaving(false);
        setSnackbar({
          open: true,
          message: "OC eliminada con éxito",
          severity: "success"
        });
        onUpdateWorkOrderState();
      })
      .catch(function(error) {
        //	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
        var error_message = "Ha ocurrido un error al eliminar la OC en SAP";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message.concat(error.message).concat(" ");
          }
        }
        if (errors.sap_response) {
          error_message = error_message
            .concat(" Respuesta SAP: ")
            .concat(errors.sap_response.body);
        }

        setSaving(false);
        setSnackbar({
          open: true,
          message: error_message,
          severity: "error"
        });
        onUpdateWorkOrderState();
      });
  };

  const deleteReceptionSAP = async () => {
    setSaving(true);
    let self = this;
    const token = localStorage.getItem("userToken");
    await axios
      .delete(
        api.work_order().forceReceptionSAP(work_order.id),
        { headers: { Authorization: `Bearer ${token}` } },
        { params: { "work_order[id]": work_order.id } }
      )
      .then(response => {
        setSaving(false);
        setSnackbar({
          open: true,
          message: "Recepcion eliminada con éxito",
          severity: "success"
        });
        onUpdateWorkOrderState();
      })
      .catch(function(error) {
        //	      		var error_message = 'Ha ocurrido un error al cargar el movimiento. Por favor contacte con su administrador'
        var error_message =
          "Ha ocurrido un error al eliminar la Recepcion en SAP";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = error_message.concat(error.message).concat(" ");
          }
        }
        if (errors.sap_response) {
          error_message = error_message
            .concat(" Respuesta SAP: ")
            .concat(errors.sap_response.body);
        }

        setSaving(false);
        setSnackbar({
          open: true,
          message: error_message,
          severity: "error"
        });
        onUpdateWorkOrderState();
      });
  };

  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={10000}
        onClose={() => {
          setSnackbar({ ...snackbar, open: false });
        }}
      >
        <Alert
          onClose={() => {
            setSnackbar({ ...snackbar, open: false });
          }}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {work_order && work_order.sap_dimensions && (
        <div className="row mt-2">
          <TextField
            id="sap_dimension_1"
            name="sap_dimension_1"
            label="Dimension 1"
            className="m-0 p-0 mr-2 col-md-2"
            value={work_order.sap_dimensions.user_cost_center || ""}
            type="text"
            disabled
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          />
          <TextField
            id="sap_dimension_2"
            name="sap_dimension_2"
            label="Dimension 2"
            className="m-0 p-0 mr-2 col-md-2"
            value={work_order.sap_dimensions.client_sap_dimension || ""}
            type="text"
            disabled
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          />
          <TextField
            id="sap_dimension_3"
            name="sap_dimension_3"
            label="Dimension 3"
            className="m-0 p-0 mr-2 col-md-2"
            value={work_order.sap_dimensions.vehicle_sap_dimension || ""}
            type="text"
            disabled
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          />
          <TextField
            id="sap_dimension_4"
            name="sap_dimension_4"
            label="Dimension 4"
            className="m-0 p-0 mr-2 col-md-2"
            value={work_order.sap_dimensions.provider_sap_dimension || ""}
            type="text"
            disabled
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          />
          <TextField
            id="sap_dimension_5"
            name="sap_dimension_5"
            label="Dimension 5"
            className="m-0 p-0 mr-2 col-md-2"
            value={work_order.sap_dimensions.product_sap_dimension || ""}
            type="text"
            disabled
            inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          />
        </div>
      )}

      <div className="row mt-2">
        <TextField
          id="oc_sap_code"
          disabled={true}
          value={work_order.oc_sap_code ? work_order.oc_sap_code : "SIN OC"}
          type="text"
          name="oc_sap_code"
          margin="normal"
          className="m-0 p-0 mr-2"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">#OC SAP</Typography>
              </InputAdornment>
            )
          }}
        />

        {work_order.oc_sap_code && (
          <>
            <Button
              disabled={saving === true ? true : false}
              className="mt-1"
              variant="contained"
              color="secondary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={e => {
                deleteOCSAP();
              }}
            >
              Eliminar OC SAP
            </Button>
          </>
        )}
        {!work_order.oc_sap_code && (
          <>
            <Button
              disabled={saving === true ? true : false}
              className="mt-1"
              variant="contained"
              color="primary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={e => {
                forceOCSAP();
              }}
            >
              Crear OC SAP
            </Button>
          </>
        )}
      </div>
      <div className="row">
        <TextField
          id="reception_sap_code"
          disabled={true}
          value={work_order.reception_sap_code}
          type="text"
          name="reception_sap_code"
          margin="normal"
          className="m-0 p-0 mr-2"
          InputLabelProps={{
            shrink: true
          }}
          inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption"># Recepcion SAP</Typography>
              </InputAdornment>
            )
          }}
        />

        {work_order.reception_sap_code && (
          <>
            <Button
              disabled={saving === true ? true : false}
              className="mt-1"
              variant="contained"
              color="secondary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={e => {
                deleteReceptionSAP();
              }}
            >
              Eliminar Recepcion SAP
            </Button>
          </>
        )}
        {!work_order.reception_sap_code && (
          <>
            <Button
              disabled={saving === true ? true : false}
              className="mt-1"
              variant="contained"
              color="primary"
              size="small"
              style={{ fontSize: "0.75rem" }}
              onClick={e => {
                forceReceptionSAP();
              }}
            >
              Crear Recepcion SAP
            </Button>
          </>
        )}
      </div>
    </>
  );
};

export default SAP;
